import React, { FC, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { REPORT_TYPES, report } from '@adsk/exo-skeleton-api';

type RedirectProps = {
  from: string;
  to: string;
};

const Redirect: FC<RedirectProps> = ({ from, to }) => {
  useEffect(() => {
    if (from) {
      void report({
        type: REPORT_TYPES.warning,
        value: `Access to deprecated route detected: ${from}`,
        context: { from },
      });
    }
  }, [from]);

  return <Navigate to={to} />;
};

Redirect.propTypes = {
  /** path to redirect from */
  from: PropTypes.string.isRequired,
  /** path to redirect to */
  to: PropTypes.string.isRequired,
};

export default Redirect;
